import { useNavigate } from 'react-router-dom';

import { useAlterarPendente as useAlterarPendenteDoNucleo } from '@maestra/core/telas/dinheiro/assinaturaPendente';
import { message } from '../../ui-carbon/padroes/avisos';

// A ASSINATURA PENDENTE (o resumo, os textos e alterar ou cancelar) mora no núcleo desde 31/10/2026:
// a conta do app mostra o mesmo (docs/PLANO-APP-NATIVO.md). A web entrega o `navigate` e o `message`.
// Valores e tipos em re-exports separados: com `type` misturado no mesmo `export {...} from`, o
// Babel do CRA descartava a linha inteira, e o webpack não achava os valores (o tsc não acusa).
export { resumoDaPendente, textosDaPendente } from '@maestra/core/telas/dinheiro/assinaturaPendente';
export type { AlterarPendente, EscolhaAnterior } from '@maestra/core/telas/dinheiro/assinaturaPendente';

export const useAlterarPendente = () => {
  const navigate = useNavigate();
  return useAlterarPendenteDoNucleo({ ir: navigate, avisar: message });
};
